module.exports = __webpack_public_path__ + "img/francis-cade.3554fda.png";